
export const initialValues = {
  countryName: "",
  activeStatus: 1,

}